<template>
    <vOrderParticularsComponent :postList="postList" v-if="flag"></vOrderParticularsComponent>
</template>
<script>
import vOrderParticularsComponent from '../../listComponent/order/OrderParticularsComponent.vue';
export default {
    name: 'orderLineList',
    components: {
        vOrderParticularsComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                order_rid: true,
                order_name: true,
                order_line_rid: true,
                product_rid: true,
                type: true,
                order_name: true,
                addBtn: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },

            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>